<template>
    <!-- 核验 -->
    <section class="checkLayout">
        <Result ref="resultNode" :resultInfo="resultInfo" />
        <div class="main">
            <h1>跨境贸易数据核验</h1>
            <el-divider></el-divider>
            <el-form :model="form" inline label-width="120px" :rules="rules" ref="ruleForm">
                <el-form-item label="存证Hash" prop="hash">
                    <el-input v-model="form.hash" placeholder="请输入存证Hash" style="width: 400px;" />
                </el-form-item>
                <div class="flex">
                    <el-form-item label="验证码" prop="captchaVal">
                        <el-input v-model="form.captchaVal" placeholder="请输入验证码" name="imgCode" style="width: 120px;" />
                    </el-form-item>
                    <div class="login_code_box">
                        <div class="img">
                            <img @click="getCodeFn" :src="imgPath" />
                        </div>
                        <div class="btn">
                            <span @click="getCodeFn">换一张</span>
                        </div>
                    </div>
                </div>
            </el-form>
            <img src="@/assets/img/home/ks.png" width="220" @click="checkData" />
        </div>
    </section>
</template>

<script>
import apiObj from "../../api/index.js"
import Result from "./result.vue"

export default {
    data() {
        return {
            rules: {
                hash: [
                    {
                        required: true,
                        message: "请输入存证Hash",
                        trigger: "blur",
                    },
                ],
                captchaVal: [
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur",
                    },
                ],
            },
            resultInfo: {},
            fileInfo: {},
            btnFlag: false,
            fileList: [],
            form: {
                hash: '',
                captchaUuid: '',
                captchaVal: ''
            },
            imgPath: "",
            imgKey: '',
        }
    },
    methods: {
        // 核验
        async checkData() {
            this.$refs["ruleForm"].validate(async (valid) => {
                if (!valid) {
                    return;
                }
                try {
                    const { flag, data, message } = await apiObj.api.ytCheck(this.form)
                    if (flag == 'T') {
                        if (data) {
                            // 成功
                            this.resultInfo = data
                            this.resultInfo.type = 'tongguo'
                        } else {
                            this.resultInfo = {
                                blockHeight: '',
                                txId: '',
                                id: '',
                                hash: this.form.hash,
                                timestamp: '',
                                type: 'shibai'
                            }
                        }
                        this.open()
                    } else {
                        this.$message.error(message)
                        this.getCodeFn()
                        this.form.captchaVal = ''
                    }
                } catch (e) {
                    this.$message.error('error')
                    this.resultInfo = {}
                }
            })
        },
        // 弹出结果页
        open(val) {
            this.$refs.resultNode.open(val)
        },
        // 获取验证码
        async getCodeFn() {
            const { data } = await apiObj.api.getPcruuid()
            this.form.captchaUuid = data.captchaUuid
            const imgData = await apiObj.api.getPcrimg({ captchaUuid: data.captchaUuid })
            const url = window.URL.createObjectURL(imgData)
            this.imgPath = url
        },
    },
    components: {
        Result
    },
    created() {
        scroll(0, 0)
        this.getCodeFn()
    }
}
</script>

<style lang="less">
@import "../../style/common.less";
</style>

<style lang="less">
.myMessage {
    width: auto !important;

    .el-message-box__message {
        width: 520px;
        margin: 0 auto;
    }
}

@media (max-width: 768px) {

    .myMessage {
        .el-message-box__message {
            width: 90%;
            margin: 0 auto;
        }
    }

}
</style>
<style lang="less" scoped>
.imgGray {
    filter: grayscale(100%);
    opacity: 0.7;
}

.imgShow {
    cursor: pointer;
}

.checkLayout {


    .main {
        width: 700px;
        height: 600px;
        margin: 80px auto 0;
        background-color: #fff;
        border-radius: 12px;
        border-right: 16px solid #437fec;
        padding: 42px 40px;
        box-shadow: 0 0 20px 5px rgba(0, 0, 0, .1);


        &>img {
            margin: 40px 0 0 80px;
        }
    }

    .login_code_box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 20px;

        .btn {
            width: 100px;
            text-align: center;
            color: #999;
            cursor: pointer;
        }

    }

}

@media (max-width: 768px) {
    .checkLayout {
        .main {
            width: 100%;
            height: auto;
            padding: 40px 20px;
        }

        .login_code_box {
            margin-bottom: 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/check2/index.vue